import React, { useEffect, useState } from 'react';
import AdvisorHistoryTables from './AdvisorHistoryTables';
import { apiErrorReason, fetchHistory } from './api';
import { SalesDialog } from '../ui';
import type { History } from './types';

interface Props {
  student: { uuid: string; name: string } | null;
  onClose: () => void;
}

// Mounted only while open, so every open reloads the history.
function HistoryBody({ studentUuid }: { studentUuid: string }) {
  const [data, setData] = useState<History | null>(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let live = true;
    fetchHistory(studentUuid)
      .then((d) => live && setData(d))
      .catch((e) => live && setError(apiErrorReason(e, 'Failed to load history')));
    return () => {
      live = false;
    };
  }, [studentUuid]);
  if (error) {
    return (
      <p role="alert" className="m-0 text-[13px]" style={{ color: 'var(--state-error)' }}>
        {error}
      </p>
    );
  }
  if (!data) {
    return <p className="m-0 text-[13px] text-content-muted">Loading history…</p>;
  }
  return <AdvisorHistoryTables data={data} />;
}

// Advisor history popup for the student profile.
function AdvisorHistoryModal({ student, onClose }: Props) {
  return (
    <SalesDialog
      open={!!student}
      onClose={onClose}
      title={student ? `Advisor history: ${student.name}` : 'Advisor history'}
      subtitle="Times in IST"
      width={960}
    >
      {student ? (
        <div className="px-4 py-3">
          <HistoryBody key={student.uuid} studentUuid={student.uuid} />
        </div>
      ) : null}
    </SalesDialog>
  );
}

export default AdvisorHistoryModal;
